<template>
  <v-list class="py-0" v-if="role.name === 'Student'">
    <StudentExam />
    <StudentUniform />
  </v-list>
</template>

<script>
import { mapState } from 'vuex'
import StudentExam from '@/components/basic/menu/StudentExam.vue'
import StudentUniform from '@/components/basic/menu/StudentUniform.vue'

export default {
  computed: {
    ...mapState('auth', ['role'])
  },
  components: {
    StudentExam,
    StudentUniform
  }
}
</script>
